import { useQuery } from "@apollo/client";
import { DocumentShowQuery, DocumentEditQuery } from "../graphql/queries";

/**
 * Хук для загрузки одного документа (для просмотра)
 */
export function useDocumentShowQuery(id: string | null, skip = false) {
  return useQuery(DocumentShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

/**
 * Хук для загрузки документа для редактирования
 */
export function useDocumentEditQuery(id: string | null, skip = false) {
  return useQuery(DocumentEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
